/**
 * @description 用于在转换过程中,对空值的处理
 */
export class ConvertTool {
    public arrayConver(data: Array<any>): Array<any> {
        if (data === null || data === undefined) {
            return []
        } else {
            return data;
        }
    };
    public objectConver(data): object {
        if (data === null || data === undefined) {
            return {}
        } else {
            return data;
        }
    }
}